import { render, staticRenderFns } from "./PersonalReviewer.vue?vue&type=template&id=0c612d5e"
import script from "./PersonalReviewer.vue?vue&type=script&lang=js"
export * from "./PersonalReviewer.vue?vue&type=script&lang=js"
import style0 from "./PersonalReviewer.vue?vue&type=style&index=0&id=0c612d5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports